import { render, staticRenderFns } from "./setting_btn.vue?vue&type=template&id=491f3edd&scoped=true&lang=pug"
import script from "./setting_btn.vue?vue&type=script&lang=js"
export * from "./setting_btn.vue?vue&type=script&lang=js"
import style0 from "./setting_btn.vue?vue&type=style&index=0&id=491f3edd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491f3edd",
  null
  
)

export default component.exports